import { useCallback } from "react";
import {  UserAccountApi, useAPIAction } from "melco-shared-logic";

export const useEnableUser = (userIdToEnable?: string ) => {
    const [enableUser] = useAPIAction(
        UserAccountApi,
        async (api ) => {
            
            const data = await api.accountEnable();
           
            return {
                successMessages: [{ message: "default" },],
               data,
            };
        },
        {
            translationPrefix: "users.actions.enable",
            defaultApiConfigOptions: { impersonationForId: userIdToEnable },
        }
    );

    return useCallback(
        async ( ) => {
           // try {
               
                await enableUser();
            //} catch (e) {
              //  return { success: false};
           // }

            return { success: true};
        },
        [enableUser]
    );
};
